import React, { memo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import '@style/components/integrationCard.scss';
import '../../../../styles/components/integrationCard.scss';
import useProjectId from '@hooks/useProjectId';
import PendoIO from '@utils/pendo';
import { colorsMapping } from '@components/colorSelector/colorSelector';
import { typeMapping } from './typeMapping';

const IntegrationCard = (props) => {
  const {
    color,
    description,
    iframe,
    link = '',
    module,
    type,
    moduleId,
    spnId,
  } = props.data;
  const history = useHistory();
  const projectId = useProjectId();
  const userId = useSelector((state) => state.login.userInfo.guid);
  const userName = useSelector(
    (state) =>
      `${state.login.userInfo.given_name} ${state.login.userInfo.family_name}`,
  );
  const handleLinkClick = () => {
    if (!link) {
      return;
    }

    PendoIO.track('Navigation Tiles - Access', {
      project_id: projectId,
      uid: userId,
      full_name: userName,
      section_name: module,
      tab_name: props.tabName,
    });

    const _link =
      link.trim().indexOf('http://') === 0 ||
      link.trim().indexOf('https://') === 0
        ? link
        : `https://${link}`;

    if ((type === 'text' && iframe) || type === 'powerbi') {
      const search = new URLSearchParams({
        integrationModuleId: moduleId,
        moduleName: module,
        from: 'tiles',
        type,
        // spnId,
        projectId,
      });
      history.push(`/projects/powerBI?${search.toString()}`);
      return;
    } else if (type === 'textContainer') {
      const search = new URLSearchParams({
        projectId,
        from: 'tiles',
        moduleName: module,
        integrationModuleId: moduleId,
      });
      history.push(`/textContainer?${search.toString()}`);
      return;
    } else if (type === 'M365') {
      const search = new URLSearchParams({
        integrationModuleId: moduleId,
        moduleName: module,
        from: 'tiles',
        type,
        projectId,
        M365: true,
      });
      history.push(`/link?${search.toString()}`);
      return;
    } else if (iframe) {
      const search = new URLSearchParams({
        projectId,
        from: 'tiles',
        moduleName: module,
        integrationModuleId: moduleId,
      });
      history.push(
        `/projects/${
          type === 'pdf' ? 'link' : 'imageLink'
        }?${search.toString()}`,
      );
      return;
    }

    try {
      window.open(_link);
    } catch (e) {
      window.open('http://Invalid link');
    }
  };

  useEffect(() => {
    const integrationModuleId = history?.location.state?.integrationModuleId;
    if (integrationModuleId && integrationModuleId === moduleId) {
      setTimeout(() => {
        // eslint-disable-next-line no-unused-vars
        const element = document
          .querySelector(`[data-module-id='${moduleId}']`)
          ?.scrollIntoView({ block: 'center' });
      }, 50);
    }
  }, []);

  return (
    <div className="integration-wrapper">
      <div
        className="integration-card"
        onClick={handleLinkClick}
        data-module-id={moduleId}
      >
        <div className="card-content">
          <div
            className="title"
            style={{ background: colorsMapping[color], color: '#fff' }}
          >
            <span>{module}</span>
            <span
              className={`appkiticon ${typeMapping[type] || typeMapping.text}`}
            />
          </div>
          <div className="desc">{description}</div>
        </div>
      </div>
    </div>
  );
};

export default memo(IntegrationCard);
